// extracted by mini-css-extract-plugin
export default {"Segment":"Segment_Segment__ejjP9","Segment_label":"Segment_Segment_label__wslEG","Semgent__active":"Segment_Semgent__active__1Rd8u","Segment_cross":"Segment_Segment_cross__J2k4n"};